import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-marca',
  templateUrl: './text-marca.component.html',
  styleUrls: ['./text-marca.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextMarcaComponent implements OnInit {

  get setValue(): string {
    return this.formGroup.get("equipamento").get("nmMarca").value
  }

  formGroup: FormGroup;

  constructor(
    private _controlContainer: ControlContainer
  ) {}

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }
  
}
